package com.solevo.dist.components.dialogs

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.JustifyContent
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.rgb
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

@Composable
fun DeleteConfirmDialog(
    title: String = "Delete Quote",
    message: String = "Are you sure you want to delete this quote. Once deleted it cannot be restored",
    confirmText: String = "Yes, Delete",
    cancelText: String = "Cancel",
    onConfirm: () -> Unit,
    onCancel: () -> Unit
) {
    Box(
        Modifier
            .position(Position.Fixed)
            .left(0.px)
            .top(0.px)
            .right(0.px)
            .bottom(0.px)
            .backgroundColor(rgb(0,0,0).copyf(alpha = 0.25f))
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .zIndex(9999)
    ) {
        Column(
            Modifier
                .width(440.px)
                .backgroundColor(rgb(255,255,255))
                .borderRadius(16.px)
                .padding(28.px)
        ) {
            SpanText(
                title,
                Modifier
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(rgb(36,41,47))
                    .textAlign(TextAlign.Center)
                    .fillMaxWidth()
            )
            Box(Modifier.height(16.px))
            SpanText(
                message,
                Modifier
                    .color(rgb(120,130,140))
                    .textAlign(TextAlign.Center)
                    .fillMaxWidth()
            )
            Box(Modifier.height(22.px))
            Column(Modifier.fillMaxWidth().gap(12.px).alignItems(AlignItems.Center)) {
                Box(
                    Modifier
                        .width(320.px)
                        .backgroundColor(rgb(236, 29, 49))
                        .color(rgb(255,255,255))
                        .padding(leftRight = 12.px, topBottom = 14.px)
                        .borderRadius(12.px)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .justifyContent(JustifyContent.Center)
                        .cursor(Cursor.Pointer)
                        .onClick { onConfirm() }
                ) {
                    SpanText(
                        confirmText,
                        Modifier
                            .color(rgb(255,255,255))
                            .fontWeight(FontWeight.Medium)
                            .textAlign(TextAlign.Center)
                            .fillMaxWidth()
                    )
                }

                Box(
                    Modifier
                        .width(320.px)
                        .backgroundColor(rgb(246,247,248))
                        .padding(leftRight = 12.px, topBottom = 14.px)
                        .borderRadius(12.px)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .justifyContent(JustifyContent.Center)
                        .cursor(Cursor.Pointer)
                        .onClick { onCancel() }
                ) {
                    SpanText(
                        cancelText,
                        Modifier
                            .textAlign(TextAlign.Center)
                            .fillMaxWidth()
                    )
                }
            }
        }
    }
}


